(ns app.front.view.payment.paypal
  (:require [app.front.entities :as entities]
            [app.front.util :as futil]
            [app.front.view.payment.checkout :as checkout]
            [app.front.view.workspace.subs :as ws-subs]
            [core.front.carbon :as cc]
            [core.front.event :refer [<sub >evt]]
            [re-frame.core-instrumented :as rf]
            [reagent.core :as r]))

(rf/reg-event-fx ::create-paypal-order
  (fn [_ [_ ctx workspace-id resolve]]
    {:comm/command {:command         :payment/paypal-order-create
                    :data            {:payment-id (:payment-id ctx)}
                    :on-bad-request  [::create.fail workspace-id resolve]
                    :on-server-error [::create.fail workspace-id resolve]
                    :on-success      [::create.success resolve]}}))

(rf/reg-event-fx ::capture-paypal-order
  (fn [{{:keys [::paypal-order-id]} :db} [_ ctx]]
    {:fx [[:dispatch [:comm/command-monitored {:command         :payment/paypal-approved-receipt
                                               :data            {:order-id   paypal-order-id
                                                                 :payment-id (:payment-id ctx)}
                                               :on-bad-request  [::capture.fail]
                                               :on-server-error [::capture.fail]
                                               :on-success      [::capture.success]}]]]}))

(rf/reg-event-fx ::create.fail
  [(rf/inject-cofx :tr)]
  (fn [{:keys [db tr]} [_ workspace-id resolve _status response]]
    (let [fail-message (str (tr [:error/payment-failed-text]) (:message response))
          nav          (checkout/return-nav-fx db :view/workspace {:workspace-id workspace-id})]
      (resolve response)
      (merge nav {:fx [[:dispatch [:notifications/add :toast :error :error/payment-failed-title fail-message]]]}))))

(rf/reg-event-fx ::create.success
  (fn [{:keys [db]} [_ resolve _status {:keys [id] :as response}]]
    (resolve response)
    {:db (assoc db ::paypal-order-id id)}))


(rf/reg-event-fx ::capture.fail
  (fn [{:keys [db]} _]
    (let [nav (checkout/return-nav-fx db :view/workspace (-> db :route/match :path-params))]
      (merge nav {:fx [[:dispatch [:notifications/add :toast :error :error/payment-failed-title :error/paypal-payment-cannot-be-instantiated]]]}))))


(rf/reg-event-fx ::capture.success
  (fn [{:keys [db]} [_ status changes]]
    (let [nav (checkout/return-nav-fx db :view/workspace (-> db :route/match :path-params))]
      (merge nav {:dispatch [::entities/apply-changes status changes]}))))

(rf/reg-event-fx ::script.fail
  (fn [{:keys [db]} [_ workspace-id]]
    (let [nav (checkout/return-nav-fx db :view/workspace {:workspace-id workspace-id})]
      (merge nav {:fx [[:dispatch [:notifications/add :toast :error :error/payment-method-not-available :error/paypal-payment-context-missing]]]}))))

(defn create-order
  "Create a promise, which gets resolved in :create.success (or fail) result. Then take the id from the result, because 
   PayPal wants the order id and nothing but the order id as a callback response."
  [ctx workspace-id]
  (-> (js/Promise. (fn [resolve _] (>evt [::create-paypal-order ctx workspace-id resolve])))
      (.then #(:id %))))

(defn capture-order [{:keys [ctx]}]
  (>evt [::capture-paypal-order ctx]))

(defn embedded-form [{:keys [ctx] :as details}]
  (let [tr (<sub [::ws-subs/tr])]
    (if (exists? js/paypal)
      (r/create-class
        {:component-did-mount (fn [_]
                                (.render (.Buttons js/paypal
                                                   (clj->js {:createOrder #(create-order ctx (:workspace-id details))
                                                             :onApprove   #(capture-order details)}))
                                         "#paypal-button-container"))
         :reagent-render      (fn [_details]
                                (if (<sub [:comm/command-processing? :payment/paypal-approved-receipt])
                                  (cc/inline-loading {:description (tr [:payment/payment-loading])})
                                  [:div.flex.flex-col.items-center.pt-8
                                   [:div {:id    "paypal-button-container"
                                          :style {:width "400px"}}]]))})
      (>evt [::script.fail (:workspace-id details)]))))


(defmethod checkout/payment-form :payment-service/paypal
  [details]
  (let [client-id (:client-id (:ctx details))
        currency  (:currency (:ctx details))]
    [futil/js-loader
     {:id  "paypal-script"
      :src (str "https://www.paypal.com/sdk/js?client-id=" client-id "&currency=" currency)}
     (cc/inline-loading {:description "Loading PayPal"})
     [embedded-form details]]))
